module.exports = __webpack_public_path__ + "assets/img/thumb-Nexon-1-Landing-Page.162f753e.webp";